/**
 * Created by pony.ma@nirvana-info on .
 */
export default function () {
  return {
    AccountId: null,
    AdditionalOutputColumns: '',
    ContactNameFlag: 0,
    ContactNameOption: 0,
    CreativeId: 0,
    CurrentStep: 'input', // 'input', 'count', 'success'
    DemoType: 1, // 99:All hoseholds, 1: others
    GeoType: 5,
    IsSaveCreative: false,
    ListType: 10,
    ListUsage: 1,
    NextStep: 6,
    OrderAddresses: [],
    OrderDate: new Date(),
    OrderGeos: [],
    OrderType: 10,
    ElementsForPricing: [],
    GeoSameState: true,
    // Don't need this
    // OrderDemos: [
    // {
    //   AttributeValue: '0',
    //   ColumnName: 'alvionacxiom30_DOBFlag',
    //   ListType: 10,
    //   OrderDemoId: 9712866,
    //   OrderId: 303144
    // }
    // ],
    // only need this
    OrderSelectedDemos: [
      // {
      //   AttributeName: 'Date of birth',
      //   ColumnName: 'alvionacxiom30_DateOfBirthU',
      //   DemoCategoryType: 3,
      //   Description: 'Date of Birth',
      //   Values: [
      //     {
      //       AttributeName: 'Date of Birth',
      //       AttributeValue: '19510~195310',
      //       AttributeValueName: '10950 to 101953',
      //       ColumnName: 'alvionacxiom30_DateOfBirthU'
      //     }
      //   ]
      // }
    ],
    PhoneOption: 0,
    Radius: 0,
    RadiusTypeChoice: 1,
    ReferFriend: '',
    RouteOption: 7,
    SeeBreakDown: true,
    SuppressionByDomain: false,
    SuppressionType: 0,
    OrderSuppressions: [],
    SaveCountSuppressions: [],
    CustomSuppressions: [],
    SuppressionEndDate: null,
    SuppressionStartDate: null,
    SaveCountSuppressionEndDate: null,
    SaveCountSuppressionStartDate: null,
    CustomSuppressionEndDate: null,
    CustomSuppressionStartDate: null,
    TargetOption: 7,
    TaxCharge: 0,
    TotalPretaxCost: 0,
    UmCode: 2,
    ZipType: 0,
    ZipcodeOriginalType: 1,
    record: '',
    CostPrice: 0,
    MediaTypeName: '',
    ShareAccountId: '',
    PackageName: '',
    TenantId: '',
    DestinationId: '',
    DestinationAccountId: '',
    EmailOption: ''
  }
}



// WEBPACK FOOTER //
// ./src/config/order.js